<template>
  <div>
    <h1>Connection Groups</h1>
    <base-card
      ><button class="btn">
        <router-link class="link" link to="/registergroup"
          >Add a new Group</router-link
        >
      </button></base-card
    >
    <base-card>
      <group-item
        v-for="group in allGroups"
        :key="group.id"
        :id="group.id"
        :members="group.members"
        :notes="group.notes"
        :groupLeader="group.groupLeader"
        :groupName="group.groupName"
      >
      </group-item
    ></base-card>
  </div>
</template>

<script>
import GroupItem from '../components/GroupItem.vue';

    export default {
      components: {
        GroupItem: GroupItem,
          
      },

        computed: {
          allGroups() {
            const groups = this.$store.getters['groups/groups']
            return groups;
          }
        },

      created() {
        this.loadMembers();
        this.loadGroups();

      },

      methods: {
        async loadMembers() {
          await this.$store.dispatch('members/loadMembers')
        },
        async loadGroups() {
          await this.$store.dispatch('groups/fetchGroups')
        }
        
      }
      
    }
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.contain :nth-child(2) {
  background-color: cadetblue;
}

.link {
  text-decoration: none;
  color: white;
}
.btn {
  background-color: cadetblue;
  color: #9a3f3f;
  padding: 0.5rem;
  border: none;
  border-radius: 0.3rem;
  width: 11em;
  font-size: 1em;
}
.box {
  width: 11em;
  height: 2em;
  border: 1px solid #999;
  font-size: 1em;
  color: white;
  background-color: cadetblue;
  border-radius: 5px;
}
.btnContainer {
  display: flex;
  justify-content: space-around;
  padding: 0.3rem;
}

.memberCard {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.memberCardTwo {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.memberList {
  width: 100%;
}

.memberCardTwo :nth-child(odd of .memberList) {
  background-color: blue;
}
input,
textarea {
  display: block;
  width: 100%;
  font: inherit;
  border: 1px solid #ccc;
  padding: 0.15rem;
}

input:focus,
textarea:focus {
  border-color: #3d008d;
  background-color: #faf6ff;
  outline: none;
}

@media only screen and (max-width: 600px) {
  .memberCardTwo,
  .card {
    margin: 0 !important;
    padding: 0 !important;
  }

  .btn {
    width: inherit;
    padding: 0.5rem;
    margin: 0.2rem;
    width: 6rem;
  }
  .container {
    display: inline-block;
    padding-bottom: 1rem;
  }
}
</style>